import { ISODateTime, LinkButton } from '@cmg/common';
import { FormattedTime } from '@cmg/i18n';
import React from 'react';

import { StyledFlexContainer } from './ProspectusDocument.styles';

export type Props = {
  fileName: string;
  url: string;
  publishedAt: ISODateTime;
};

export const ProspectusDocument: React.FC<Props> = ({ fileName, url, publishedAt }) => {
  return (
    <StyledFlexContainer direction="row">
      <LinkButton inline href={url} target="_blank">
        {fileName}
      </LinkButton>
      Published: <FormattedTime value={publishedAt} format="dateTime" />
    </StyledFlexContainer>
  );
};
